// =====================================================================
//  Controller de lecture des stratégies OTP — appels HTTP réels.
//  Route proxy : POST /otp-strategy (ClientWrapper -> WEB_API).
// =====================================================================

import {ResponseApi} from "../../Model/ResponseApi.js";
import {JsonFetchJson} from "../../Helper/FetchHelper.js";
import {
    IOtpStrategyFilterModel,
    IOtpStrategyModel,
} from "../../Model/Otp/OtpStrategyModel.js";

export class OtpRead {
    public static Read = async (filter: IOtpStrategyFilterModel): Promise<IOtpStrategyModel[]> => {
        return JsonFetchJson.Post<ResponseApi<Array<IOtpStrategyModel>>>("/otp-strategy", filter)
            .then((response) => response.Data ?? []);
    };
}
